//
//
//
//
//
//
//
//
//

export default {
  name: 'banner_service',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};